export default import.meta.ROLLDOWN_FILE_URL_03sErh0A0F1x6yI3rSUXkw